__turbopack_context__.v({
  "body": "CDedicatedDescriptivePage-module__9bXFMG__body",
  "empty": "CDedicatedDescriptivePage-module__9bXFMG__empty",
  "paragraph": "CDedicatedDescriptivePage-module__9bXFMG__paragraph",
  "paragraphText": "CDedicatedDescriptivePage-module__9bXFMG__paragraphText",
  "paragraphUnsupported": "CDedicatedDescriptivePage-module__9bXFMG__paragraphUnsupported",
});
